<template>
  <main>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Preview</b-card-title>
        <b-card-title>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15 )'"
            variant="primary"
            @click="onPrint"
          >
            <feather-icon
              icon="PrinterIcon"
              class="mr-50"
            />
            Print
          </b-button>
        </b-card-title>
      </b-card-header>
      <b-card-body>
        <poster-design
          :data="voucher"
          :qr-data="url"
        />
      </b-card-body>
    </b-card>
  </main>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import print from 'vue-print-nb'
import PosterDesign from './PosterDesign.vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,

    PosterDesign,
  },
  directives: {
    Ripple,
    print,
  },
  data() {
    return {
      qrData: {
        value: `${process.env.VUE_APP_CLIENT_URL}/voucher/claim/${this.voucherId}`,
      },
    }
  },
  computed: {
    ...mapState('voucher', ['voucher']),
    voucherId() {
      return this.$route.params.id
    },
    url() {
      return {
        value: `${process.env.VUE_APP_CLIENT_URL}/voucher/claim/${this.voucherId}`,
      }
    },
  },
  async created() {
    try {
      await this.getVoucherDetail({ voucherId: this.voucherId })
    } catch (error) {
      this.$swal({
        title: 'Error!',
        text: error.message,
        icon: 'error',
        timer: 3000,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    }
  },
  methods: {
    ...mapActions('voucher', ['getVoucherDetail']),
    onPrint() {
      const link = `/vouchers/${this.voucherId}/poster/print`
      window.open(link, '_blank')
    },
  },
}
</script>
